import React, { useEffect, useState } from 'react';
import { catTreeWithfahrast, getPersianDayOfWeek, persianDate } from '../../../../module/ConstantFunctions';
import Spinner from '../../../../Constants/Spinner';

import PlusBoxIcon from '../../../../Assets/Icons/PlusBoxIcon';
import ViewIcon from '../../../../Assets/Icons/ViewIcon';
import EditIcon from '../../../../Assets/Icons/EditIcon';
import DeleteIcon from '../../../../Assets/Icons/DeleteIcon';
import { Link } from 'react-router-dom';
import DraftPostModal from '../../components/DraftPostModal';

function PastHadithRow({ a, i, addToDay, activeIndex, setActiveIndex }) {
  const [deleteHadithOfDayLoader, setDeleteHadithOfDayLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <div
      key={i}
      className={`pasthadiths mt-[24px] ${
        !activeIndex.includes(i) ? 'bg-[#EEF2F0] py-2 pl-2 pr-6 rounded-[10px]' : ''
      } `}>
      <div className="flex items-center justify-between ">
        {!activeIndex.includes(i) ? (
          <button
            className="p-[10px] bg-[#2A9134] rounded-[10px]"
            onClick={() => {
              let arr = [...activeIndex];
              arr.push(i);
              setActiveIndex(arr);
            }}>
            <PlusBoxIcon pathProp={{ stroke: '#fff' }} />
          </button>
        ) : (
          <div></div>
        )}
        <p className="font-bold  text-[#0e3a1f] text-right text-xl leading-[16px]">
          {getPersianDayOfWeek(a.hadith_date_post)} {persianDate(a.hadith_date_post)}
        </p>
      </div>
      <div
        className={activeIndex.includes(i) ? 'lg:h-[288px] h-[302px]' : 'h-0'}
        style={{ transition: '0.2s', overflow: 'hidden' }}>
        <div className="items-center justify-between bg-[#eef7ef] border-[1px] border-[#2a9134]  px-6 py-6 rounded-lg w-full mt-[16px]">
          <div className="flex items-center justify-end w-full mb-6 relative">
            <div className="flex items-center  justify-end w-full   text-text-ellipsis">
              <span className="line-clamp-1 text-ellipsis  numberHaith font-bold urduText ml-[16px] text-[#0e3a1f] text-[21px]">
                {a.reference}
              </span>
            </div>
          </div>
          <p dir="ltr" className="urduText leading-[36px] font-bold line-clamp-2 text-text-ellipsis text-right">
            {a.preview}
          </p>
          <div className="flex items-center  justify-end w-full   text-text-ellipsis">
            <p
              dir="ltr"
              className="line-clamp-1 text-ellipsis  urduText font-normal text-[#0e3a1f]  text-[20px] text-text-ellipsis">
              {catTreeWithfahrast(a)}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-between  mt-[16px]">
          <button
            className="h-[48px] w-[48%] flex items-center justify-center  bg-[#2a9134] rounded-xl text-white"
            onClick={showModal}>
            <ViewIcon className="mr-2" />
            View Hadith
          </button>
          <Link className="h-[48px] w-[24%]" to={`/edit-post?id=${a._id}`}>
            <button className="flex items-center justify-center h-full w-full bg-[#eef2f0] rounded-xl">
              <EditIcon width={26} height={24} fill="#000" />
            </button>
          </Link>
          <button
            className="flex items-center justify-center h-[48px] w-[24%] bg-[#ca3030] rounded-xl"
            onClick={() => addToDay(a, setDeleteHadithOfDayLoader, '')}>
            {deleteHadithOfDayLoader ? <Spinner /> : null}

            <span
              className={
                deleteHadithOfDayLoader
                  ? `opacity-0 flex items-center justify-center`
                  : 'flex items-center justify-center'
              }>
              <DeleteIcon svgProps={{ className: 'w-[24px] h-[24px]' }} pathProp={{ fill: '#fff' }} />
            </span>
          </button>
        </div>
      </div>
      <DraftPostModal
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        data={a}
        actionButtons={false}
      />
    </div>
  );
}

export default PastHadithRow;
